/**
 * Lazy-loads the Konva core so the app bundler emits a separate chunk.
 * Also registers shapes used by the floor plan (F2 perimeter/tables, F3 groups/arcs).
 */
export async function loadKonvaCore(): Promise<any> {
  const mod: any = await import('konva/lib/Core');
  const Konva = mod.default ?? mod;
  await import('konva/lib/shapes/Rect');
  await import('konva/lib/shapes/Line');
  await import('konva/lib/shapes/Text');
  await import('konva/lib/Group');
  await import('konva/lib/shapes/Arc');
  await import('konva/lib/shapes/Circle');
  await import('konva/lib/shapes/Ellipse');
  await import('konva/lib/shapes/Transformer');
  return Konva;
}
